<select class="form-control" [name]="filter.name" [id]="filter.apiFilter" (change)="onChange($event)" [disabled]="disabled">
  <option selected value="null">{{filter.placeholder}}</option>
  <option *ngFor="let item of filterData" [value]="item._id">{{item.name}}</option>
</select>
 